

























































































































import { Vue, Component } from "vue-property-decorator";
import { $api } from "@/services/ApiService";
import { User, UserState, UserRole } from "bancojs";
import AgDataTable, { AgDataTableOptions } from "@/components/AgDataTable.vue";

export function getRoleString(val: UserRole) {
  switch (val) {
    case "ADMIN_CERTIFICATES": {
      return "Admin Certificados";
    }
    case "ADMIN_USERS": {
      return "Admin Usuarios";
    }
    case "ADMIN_CLIENTS": {
      return "Admin Clientes";
    }
    case "ADMIN_KEYS": {
      return "Admin Llaves";
    }
    default: {
      return "Admin";
    }
  }
}

@Component({
  components: {
    AgDataTable,
  },
})
export default class AdminUsersIndex extends Vue {
  async created() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.table.loading = true;
      const res = await $api.client.admin.users.find({}).toPromise();
      this.table.data = res.content;
    } catch (err) {
      console.log(err);
    } finally{
      this.table.loading = false;
    }
    
  }

  getStateString(val: UserState) {
    return val === "ACTIVE" ? "Activo" : "Inactivo";
  }

  openRemove(item: User) {
    this.table.selected = item;
  }

  closeRemove() {
    this.table.selected = null;
    this.dialog.valid = false;
    this.dialog.confirm = null;
  }

  get removeDialog() {
    return !!this.table.selected;
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
    matches: (val: string) =>
      (this.table.selected && this.table.selected.id == val) ||
      "El ID de usuario no es correcto.",
  };

  async removeUser(id: string) {
    try {
      this.dialog.loading = true;
      await $api.client.admin.users.destroy(id).toPromise();
      this.dialog.loading = false;
      this.closeRemove();
      await this.loadData();
    } catch (err) {
      console.log(err);
      this.dialog.loading = false;
      this.closeRemove();
    }
  }

  dialog: {
    loading: boolean;
    valid: boolean;
    confirm: string | null;
  } = {
    loading: false,
    valid: false,
    confirm: null,
  };

  table: {
    loading: boolean;
    selected: User | null;
    data: User[];
    options: AgDataTableOptions[];
  } = {
    loading: true,
    selected: null,
    data: [],
    options: [
      {
        header: {
          text: "#",
          value: "$index",
          width: 60,
          filterable: false,
          sortable: false,
        },
        row: {
          type: "INDEX",
        },
      },
      {
        header: {
          text: "ID",
          value: "id",
          class: "text-no-wrap",
        },
        row: {
          type: "LINK",
          to: "{id}/edit",
          append: true,
        },
      },
      {
        header: {
          text: "Nombre",
          value: "name",
          class: "text-no-wrap",
        },
        row: {
          type: "TEXT",
        },
      },
      {
        header: {
          text: "Email",
          value: "email",
          class: "text-no-wrap",
        },
        row: {
          type: "TEXT",
        },
      },
      {
        header: {
          text: "Estado",
          value: "state",
          class: "text-no-wrap",
        },
        row: {
          type: "CHIP",
          label: true,
          color: {
            ACTIVE: "success",
            INACTIVE: "error",
          },
          transform: this.getStateString,
        },
      },
      {
        header: {
          text: "Roles",
          value: "roles",
          class: "text-no-wrap",
          sortable: false,
          filter: (value, search, item) => {
            return (
              !search ||
              (Array.isArray(item.roles) &&
                (item.roles as Array<string>).includes(value.toUpperCase()))
            );
          },
        },
        row: {
          type: "CHIP",
          label: true,
          color: {},
          transform: (roles: string[]) => {
            return roles.length.toString();
          },
          tooltip: true,
          tooltipContent: (val: UserRole[]) => {
            let html = "";
            val.forEach((role) => {
              html += "<div>" + getRoleString(role) + "</div>";
            });
            return html;
          },
        },
      },
      {
        header: {
          text: "",
          class: "text-no-wrap",
          value: "$options",
          sortable: false,
          filterable: false,
        },
        row: {
          type: "OPTIONS",
          options: [
            {
              label: "Editar",
              icon: "mdi-pencil",
              link: "{id}/edit",
              append: true,
            },
            {
              label: "Eliminar",
              icon: "mdi-delete",
              action: (item: User) => {
                this.openRemove(item);
              },
            },
          ],
        },
      },
    ],
  };
}
